export class DeleteParameters {
    scheduleId: number = 0;
    dispatchId: number = 0;
    loadId: number = 0;
    title: string = "";
}